import axios from 'axios'
import {getTokenCookie} from "@/utils/cookie";
import {Message} from "element-ui";
import router from "@/router";
import store from "@/store";
import {Toast} from "vant";


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: '/dev-api', // 开发环境/测试环境
  // baseURL: 'pre-api', // 预发布环境
  baseURL: 'pro-api', // 生产环境
  // 超时
  timeout: 30000
})

// 请求拦截器：从Cookie读取Token并添加到请求头
service.interceptors.request.use(
    config => {
        const token = getTokenCookie()
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器：仍需处理401（Token过期）
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 401) {
            Toast('登录已过期，请重新登录')
            store.dispatch('logout')
            if (router.currentRoute.path !== '/app_login') {
                router.push({ path: '/app_login', query: { redirect: router.currentRoute.fullPath } })
            }
        }
        return res
    },
    error => {
        if (error.response?.status === 401) {
            Toast('登录已过期，请重新登录')
            store.dispatch('logout')
            if (router.currentRoute.path !== '/app_login') {
                router.push({ path: '/app_login', query: { redirect: router.currentRoute.fullPath } })
            }
        } else {
            Message.error(error.message || '服务器错误')
        }
        return Promise.reject(error)
    }
)


export default service
